<p>detail-stand-client works! {{idClient}}</p>
